import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { TimeSeriesChartService } from '../time-series-charts.service';
import { FieldDef } from 'app/core/models';
import { CurrencyMaskOptions, getCurrencyMask } from 'app/shared/Utils/common.utils';
import { AccountService } from 'app/core';
import { Observable, delay, filter, map, of, startWith } from 'rxjs';
import { ConfirmService } from 'app/shared/components/widgets/dialog/confirm/confirm.service';

@Component({
  selector: 'add-time-series-value',
  templateUrl: './add-time-series-value.component.html',
  styleUrls: ['./add-time-series-value.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddTimeSeriesValueComponent implements OnInit {
  public addTimeSeriesChartForm: UntypedFormGroup;
  public fields: FieldDef[] = [];
  public isCurrencyField: boolean = false;
  public timeSeriesChartId: number;
  selectedField: FieldDef;
  fields$;

  private get accountCurrency(): string {
    return this._accountService.getCurrentAccount()?.display_currency;
  }

  get currencyMaskOptions(): CurrencyMaskOptions {
    return getCurrencyMask(this.accountCurrency, 0);
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<AddTimeSeriesValueComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _timeSeriesChartService: TimeSeriesChartService,
    private _accountService: AccountService,
    private readonly confirmService: ConfirmService,
  ) {}

  ngOnInit(): void {
    this.addTimeSeriesChartForm = this._formBuilder.group({
      field_name: ['', [Validators.required]],
      date: ['', [Validators.required]],
      related_to_type: ['Project'],
      val: [''],
      id: [''],
    });

    //this.addTimeSeriesChartForm.patchValue(this.data);
    this.fields = this.data.fields.sort((a, b) => a.name.localeCompare(b.name));
    this.timeSeriesChartId = this.data.timeSeriesChartId;

    if (this.data.model) {
      this.addTimeSeriesChartForm.patchValue(this.data.model);
    }
  }

  selectFieldOptions() {
    return this.fields.map(({ id, name, label }) => ({ id, name, label })).sort((a, b) => a.name.localeCompare(b.name));
  }

  displayFn(value) {
    const field = this.fields?.find((item) => item.name === value);
    return field?.label;
  }

  private _filter(value) {
    const filterValue = value?.toLowerCase();
    return this.fields.filter((option) => option.name.toLowerCase().includes(filterValue));
  }

  discard(): void {
    this.matDialogRef.close();
  }

  deleteTimeSeriesValue(): void {
    this.confirmService
      .openConfirmationModal()
      .pipe(filter((res: boolean) => res))
      .subscribe(() => {
        const vals = this.addTimeSeriesChartForm.value;
        this._timeSeriesChartService
          .deleteFieldValue(this.timeSeriesChartId, vals.date, vals.field_name, vals.id)
          .subscribe((timeSeriesChart) => {
            this.discard();
          });
      });
  }

  save(): void {
    const vals = this.addTimeSeriesChartForm.value;
    this._timeSeriesChartService
      .setFieldValue(this.timeSeriesChartId, vals.val, vals.date, vals.field_name, vals.id)
      .subscribe((timeSeriesChart) => {
        this.discard();
      });
  }

  onFieldSelection($event: any): void {
    this.selectedField = this.fields.find((item) => item.name === $event.field_name);
    this.addTimeSeriesChartForm.get('field_name').patchValue(this.selectedField.name);
    this.addTimeSeriesChartForm.updateValueAndValidity();
    this.isCurrencyField = this.selectedField.type == 'money';
  }
}
